var N = Object.defineProperty, R = Object.defineProperties;
var b = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, j = Object.prototype.propertyIsEnumerable;
var l = (r, o, t) => o in r ? N(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t, i = (r, o) => {
  for (var t in o || (o = {}))
    h.call(o, t) && l(r, t, o[t]);
  if (s)
    for (var t of s(o))
      j.call(o, t) && l(r, t, o[t]);
  return r;
}, m = (r, o) => R(r, b(o));
import { jsxs as f, jsx as n } from "react/jsx-runtime";
import "react-popper-tooltip/dist/styles.css";
import e from "../../../node_modules/prop-types/index.es.js";
import w from "react";
import { usePopperTooltip as O } from "react-popper-tooltip";
import * as v from "./style.es.js";
import { Tooltip as x, TooltipChildren as A, TooltipContent as E, TooltipContentArrow as S } from "./style.es.js";
import { COMPONENT_SIZE as T } from "../../../constants/sizes.es.js";
const p = w.forwardRef(({
  active: r = !0,
  children: o,
  content: t,
  tooltipConfig: a = {},
  size: c = T.md
}, d) => {
  const {
    getArrowProps: P,
    getTooltipProps: g,
    setTooltipRef: u,
    setTriggerRef: y,
    visible: C
  } = O(a);
  return /* @__PURE__ */ f(x, { ref: d, children: [
    /* @__PURE__ */ n(A, { ref: y, children: o }),
    r && C && t && /* @__PURE__ */ f(E, m(i({ ref: u, size: c }, g({
      className: "tooltip-container"
    })), { children: [
      /* @__PURE__ */ n(S, i({}, P({
        className: "tooltip-arrow"
      }))),
      t
    ] }))
  ] });
}), q = {
  active: e.bool,
  children: e.node.isRequired,
  size: e.oneOf(Object.values(T)),
  tooltipConfig: e.object
};
p.S = v;
p.displayName = "Tooltip";
p.propTypes = q;
export {
  p as Tooltip,
  q as tooltipPropTypes
};
//# sourceMappingURL=Tooltip.es.js.map
